// The address validation rule, lifted verbatim — the identical body sat in
// OrderAddressInlineInput.tsx, LogisticAddressInlineInput.tsx and
// PurchaseOrderAddressInlineInput.tsx (`code-rule.md` → "DRY — Rule of Two").
export const validateAddress = (value: any) => {
  if (!value?.city || !value?.state || !value?.zip || !value?.country) {
    throw new Error('At least city, state, zip, country should be provided.')
  }
}
